import { getAdminBookingById } from '@/api/booking';
import BookingConsultantDetailed from '@/components/admin/detailed/bookings/BookingConsultantDetailed';
import BookingDetailed from '@/components/admin/detailed/bookings/BookingDetailed';
import BookingFranchiseDetailed from '@/components/admin/detailed/bookings/BookingFranchiseDetailed';
import { useQuery } from '@tanstack/react-query';
import { Flex, Row, Typography } from 'antd';
import { Layout as BaseLayout } from 'antd';
import { useParams } from 'react-router';

export default function AdminBookingsDetailedPage() {
  const { id } = useParams();
  const { data } = useQuery({
    queryKey: ['booking', id],
    queryFn: () => getAdminBookingById(id || ''),
  });

  return (
    <>
      <Flex justify="space-between" align="center" gap={24}>
        <div>
          <Typography.Title
            level={2}
            style={{
              margin: '0 0 24px',
            }}
          >
            Booking Details
          </Typography.Title>
          <Row className="tables-info">
            <Typography.Text style={{ color: '#9FA1AD', fontWeight: 500 }}>
              Booking Management
            </Typography.Text>
            <span className="tables-divider" />
            <Typography.Text style={{ color: '#9FA1AD', fontWeight: 500 }}>
              Booking Details
            </Typography.Text>
          </Row>
        </div>
      </Flex>
      <BaseLayout>
        <BaseLayout.Content style={{ padding: '0 16px' }}>
          <Flex gap={24} style={{ flex: 1 }}>
            <BookingDetailed booking={data} />
            <BookingConsultantDetailed consultant={data?.consultant} />
            <BookingFranchiseDetailed franchise={data?.franchise} />
          </Flex>
        </BaseLayout.Content>
      </BaseLayout>
    </>
  );
}
